exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[data-v-6b298c0c] {\n  width: 90px;\n  text-align: center;\n  float: right;\n  margin-bottom: 0;\n}\n.btn-lg-green[data-v-6b298c0c] {\n  width: 180px;\n}\n.in-padd[data-v-6b298c0c] {\n  padding: 30px;\n}\n\n/* hr {\n  margin-top: 0;\n} */\n.row:last-child hr[data-v-6b298c0c] {\n  display: none;\n}\nlabel[data-v-6b298c0c] {\n  padding-bottom: 20px;\n  max-width: calc(100% - 100px);\n}\n@media only screen and (max-width: 575px) {\n.btn-lg-green[data-v-6b298c0c] {\n    width: 100%;\n}\n.in-padd[data-v-6b298c0c] {\n    padding: 15px;\n}\n}\n", ""]);

// exports
